export default __webpack_public_path__ + "static/media/evaluation-method.d11c7480.png";